import '../modules/slider-mobile-gallery';